import { useContext } from 'react';
import { Notification } from '@components/notification';
import { ToastContext } from '@contexts/toast/toast-context';

export const ToastContainer = () => {
  const toastContext = useContext(ToastContext);

  function handleRemove(id: string) {
    toastContext.remove(id);
  }

  return (
    <div
      aria-live='assertive'
      className='fixed z-50 inset-0 flex flex-col justify-start items-center space-y-8 px-4 py-6 pointer-events-none sm:items-end sm:p-6'>
      {toastContext.data.map((toast) => {
        return (
          <Notification
            type={toast.type}
            key={toast.id}
            id={toast.id}
            title={toast.title}
            text={toast.text}
            onRemove={handleRemove}
            lifetime={toast.lifetime}
            disableTimeOut={toast.disableTimeOut}
          />
        );
      })}
    </div>
  );
};
